import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData 
}) => {
  const siteName = 'Digital Shark';
  const baseUrl = 'https://digitalshark.tv';
  const defaultImage = '/DarkNavLogo.png';
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Caribbean Television Production & Live Streaming`;
  const fullDescription = description || 'Professional television production, live streaming, and broadcast services in Barbados. Specializing in sports events, documentaries, and Pay Per View systems across the Caribbean.';
  const fullKeywords = keywords || 'television production, live streaming, broadcast services, Caribbean, Barbados, sports broadcasting, documentary production, Pay Per View, PPV systems, live events, streaming technology, video production, French Village St Peter, Digital Shark';
  const fullImage = image ? `${baseUrl}${image}` : `${baseUrl}${defaultImage}`;
  const fullUrl = url ? `${baseUrl}${url}` : baseUrl;

  useEffect(() => {
    // Update document title
    document.title = fullTitle;
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', fullDescription);
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', fullKeywords);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const ogDescription = document.querySelector('meta[property="og:description"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');
    const ogImage = document.querySelector('meta[property="og:image"]');
    const ogType = document.querySelector('meta[property="og:type"]');

    if (ogTitle) ogTitle.setAttribute('content', fullTitle);
    if (ogDescription) ogDescription.setAttribute('content', fullDescription);
    if (ogUrl) ogUrl.setAttribute('content', fullUrl);
    if (ogImage) ogImage.setAttribute('content', fullImage);
    if (ogType) ogType.setAttribute('content', type);

    // Update Twitter tags
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    const twitterDescription = document.querySelector('meta[property="twitter:description"]');
    const twitterUrl = document.querySelector('meta[property="twitter:url"]');
    const twitterImage = document.querySelector('meta[property="twitter:image"]');

    if (twitterTitle) twitterTitle.setAttribute('content', fullTitle);
    if (twitterDescription) twitterDescription.setAttribute('content', fullDescription);
    if (twitterUrl) twitterUrl.setAttribute('content', fullUrl);
    if (twitterImage) twitterImage.setAttribute('content', fullImage);

    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', fullUrl);
    }

    // Add structured data if provided
    if (structuredData) {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }, [fullTitle, fullDescription, fullKeywords, fullUrl, fullImage, type, structuredData]);

  return null; // This component doesn't render anything
};

export default SEO;
